/**
 * Positions a reader word popup (mounted in a `.yourWordPopUpContainer`
 * inside `containerElement`) relative to the clicked word: the mount element
 * is laid over the word's line, the popup flips above or below depending on
 * which half of the container the word is in, and the dismiss area is cut out
 * around the word itself. Shared by the your-word popup and the reading-guide
 * glossary popover.
 */
export const positionWordPopUp = ({
  targetElement,
  containerElement,
  mountEl,
  popUp,
  dismissArea,
}: {
  targetElement: JQuery<HTMLElement>;
  containerElement: JQuery<HTMLElement>;
  mountEl: HTMLElement;
  popUp: HTMLElement | null;
  dismissArea: HTMLElement | null;
}) => {
  const targetOffset = targetElement.offset();
  const containerOffset = containerElement.offset();
  if (!targetOffset || !containerOffset) return;

  const verticalPadding = 8;
  const horizontalMargin = 20;

  mountEl.style.top =
    targetOffset.top - containerOffset.top - verticalPadding + "px";
  mountEl.style.left = horizontalMargin + "px";
  mountEl.style.right = horizontalMargin + "px";
  mountEl.style.height = targetElement.height() + verticalPadding * 2 + "px";

  if (!popUp || !dismissArea) {
    return;
  }

  dismissArea.style.left =
    targetOffset.left - containerOffset.left - horizontalMargin + "px";
  dismissArea.style.width = targetElement.width() + "px";

  popUp.classList.remove("yourWordPopUp-above", "yourWordPopUp-below");

  const halfY =
    targetOffset.top - containerOffset.top + targetElement.height() / 2;

  let maxHeight: number;
  if (halfY > containerElement.height() / 2) {
    popUp.classList.add("yourWordPopUp-above");
    maxHeight = halfY - 50;
  } else {
    popUp.classList.add("yourWordPopUp-below");
    maxHeight = containerElement.height() - halfY - 40;
  }
  popUp.style.maxHeight = maxHeight + "px";
};
